import React, { useState } from 'react';
import { collection, writeBatch, doc, serverTimestamp } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { toast } from 'react-hot-toast';

const newPlans = [
  {
    id: 'plan-1',
    name: 'Complete Evaluation',
    description: 'Great for Sr. Managers',
    basePrice: 199,
    maxEvaluators: 5,
    status: 'active',
    features: [
      'Comprehensive performance evaluation',
      'General leadership assessment',
      'Core competencies analysis',
      'Professional impact measurement'
    ],
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/objectivephoto.webp?alt=media&token=3a0a0d4c-76fa-4d64-bdef-bcb0376c70c5'
  },
  {
    id: 'plan-2',
    name: 'Leadership Edge',
    description: 'Focused on assessing and developing leadership potential',
    basePrice: 499,
    maxEvaluators: 10,
    status: 'active',
    features: [
      'Deep dive into leadership traits',
      'Emotional intelligence assessment',
      'Executive presence evaluation',
      'Decision-making analysis'
    ],
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/objectivephoto.webp?alt=media&token=3a0a0d4c-76fa-4d64-bdef-bcb0376c70c5'
  },
  {
    id: 'plan-3',
    name: 'Career Accelerator',
    description: 'Designed to map out your career trajectory',
    basePrice: 799,
    maxEvaluators: 10,
    status: 'active',
    features: [
      'Career path mapping',
      'Skill gap analysis',
      'Industry alignment check',
      'Growth opportunity identification'
    ],
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/objectivephoto.webp?alt=media&token=3a0a0d4c-76fa-4d64-bdef-bcb0376c70c5'
  },
  {
    id: 'plan-4',
    name: 'Collaboration Genius',
    description: 'Enhances team dynamics and interpersonal effectiveness',
    basePrice: 999,
    maxEvaluators: 10,
    status: 'active',
    features: [
      'Team dynamics assessment',
      'Communication style analysis',
      'Conflict resolution evaluation',
      'Remote collaboration effectiveness'
    ],
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/objectivephoto.webp?alt=media&token=3a0a0d4c-76fa-4d64-bdef-bcb0376c70c5'
  }
];

export default function PlansTest() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<string>('');

  const handleCreatePlans = async () => {
    setLoading(true);
    setStatus('Creating new plans...');

    try {
      const batch = writeBatch(db);
      const plansRef = collection(db, collections.plans);

      newPlans.forEach(plan => {
        const docRef = doc(plansRef, plan.id);
        batch.set(docRef, {
          ...plan,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      });

      await batch.commit();
      setStatus('✅ Plans created successfully');
      toast.success('Plans updated successfully');
    } catch (error) {
      console.error('Error creating plans:', error);
      setStatus('❌ Error creating plans');
      toast.error('Failed to update plans');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="p-3 bg-gray-50 rounded border">
        <p className="font-mono text-sm">{status || 'Ready to create new plans'}</p>
      </div>
      
      <button
        onClick={handleCreatePlans}
        disabled={loading}
        className="w-full bg-primary text-dark px-4 py-2 rounded hover:bg-primary-hover transition-colors disabled:opacity-50"
      >
        {loading ? 'Creating Plans...' : 'Create New Plans'}
      </button>
    </div>
  );
}